import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";

@Injectable()
export class ImagesService {
  constructor(private httpClient: HttpClient) {}

  public getImageBlob(image_name): Observable<any> {
    return this.httpClient
      .get("/assets/images/" + image_name, { responseType: "blob" })
      .pipe(tap((_) => console.log("ImagesService.getImageBlob: Ok.")));
  }
}
